import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../pages/Home/redux/actions';
import * as selectors from '../pages/Home/redux/reducer';

import { withStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { Typography, Avatar } from '@material-ui/core';
import links from 'utils/links';
import Logout from './Logout';
// import axios from 'axios';
import autoBind from 'react-autobind';
import userInfo from 'utils/userInfo';
import { storeCityName, getCityName } from 'utils/';

const styles = {
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  menuButton: {
    marginRight: -12,
    marginLeft: 10,
  },
  top: {
    marginTop: '25px',
    position: 'relative',
    left: '16px',
    width: '100px',
  },
  loginBtn: {
    marginLeft: '35px',
    marginTop: '25px',
    width: '100px',
  },
  currentCity: {
    position: 'relative',
    left: '20px',
    top: '10px',
  },
  contentWhenUserLogin: {
    position: 'relative',
    top: '3vh',
    bottom: '0',
  },
  profileContainer: {
    position: 'relative',
    top: '0',
  },
  avatarPic: {
    left: '15px',
    width: '50px',
    height: '50px',
    top: '5px',
    display: 'inline-block',
  },
  profileName: {
    display: 'inline-block',
    position: 'fixed',
    marginTop: '10px',
    marginLeft: '25px',
    wordSpacing: '200px',
  },
  formControl: {
    marginTop: '-24px',
    width: '100px',
    minWidth: 120,
  },
  exploreBtn: {
    height: '30px',
    backgroundColor: 'white',
    top: '20px',
    left: '6px',
  },
};

class SwipeableTemporaryDrawer extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  state = {
    right: false,
    contributorFetchedData: null,
  };
  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };

  componentDidMount() {
    this.props.dispatch(actions.getData());
  }
  handleChange = event => {
    storeCityName(event.target.value);
    console.log(this.props);
    this.props.history.push(links.home());
  };
  render() {
    const { classes, history, cities } = this.props;
    const city = getCityName();
    const genericLinks = [
      {
        name: 'Eateries',
        link: links.eateryLanding(city),
      },
      {
        name: 'Culinary Experiences',
        link: links.experiences(city),
      },
      {
        name: 'Community',
        link: links.staticLink('community'),
      },
      {
        name: 'About Talking Street',
        link: links.staticLink('about-us'),
      },
    ];
    const userLinks = [
      {
        name: 'Profile Settings',
        link: links.staticLink('my-profile'),
      },
      {
        name: 'My DashBoard',
        link: links.contributorDashboardLink(),
      },
    ];
    const checkLoginStatus = () => {
      if (!userInfo.doesUserExist()) {
        return (
          <React.Fragment>
            <Grid container spacing={8}>
              <Grid item>
                <Link to={links.loginLink()}>
                  <Button
                    variant="contained"
                    color="secondary"
                    style={styles.top}
                  >
                    Sign in
                  </Button>
                </Link>
                {/*</a>*/}
                <Link to={links.loginLink()}>
                  <Button
                    variant="contained"
                    color="secondary"
                    style={styles.loginBtn}
                  >
                    Sign up
                  </Button>
                </Link>
              </Grid>
              <Typography
                component="p"
                variant="subtitle1"
                style={styles.currentCity}
              >
                Current City: {city}
              </Typography>
            </Grid>
            <br />
            <br />
            <Divider />
          </React.Fragment>
        );
      }
    };
    const displayUsrProfile = () => {
      if (userInfo.doesUserExist()) {
        return (
          <React.Fragment>
            <div style={styles.profileContainer}>
              <div>
                <Avatar
                  alt={userInfo.getUserDisplayName()}
                  src={userInfo.getUserImage()}
                  style={styles.avatarPic}
                />
                <Typography
                  style={styles.profileName}
                  variant="subtitle1"
                  component="span"
                >
                  {userInfo.getUserDisplayName()}
                </Typography>
              </div>
              <br />
              <Typography
                component="span"
                variant="subtitle1"
                style={styles.currentCity}
              >
                Current City:
                <FormControl
                  variant="outlined"
                  className={[classes.formControl, classes.exploreBtn].join(
                    ' '
                  )}
                >
                  <InputLabel
                    ref={ref => {
                      this.InputLabelRef = ref;
                    }}
                    htmlFor="explore-city"
                  />
                  <Select
                    native
                    value={city}
                    style={{ height: '30px' }}
                    history={history}
                    onChange={this.handleChange}
                    input={
                      <OutlinedInput
                        labelWidth={100}
                        name="city"
                        id="explore-city"
                      />
                    }
                  >
                    {cities.map(city => (
                      <option
                        key={city.cityID}
                        value={city.cityID}
                        history={history}
                      >
                        {city.cityName}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Typography>
              <br />
              <Divider />
            </div>
          </React.Fragment>
        );
      }
    };
    const displayWhenUserLogin = () => {
      if (userInfo.doesUserExist()) {
        return (
          <div style={styles.contentWhenUserLogin}>
            <List>
              {userLinks.map((item, index) => (
                <ListItem
                  button
                  key={item.name}
                  component={Link}
                  to={item.link}
                  onClick={this.toggleDrawer('right', false)}
                  onKeyDown={this.toggleDrawer('right', false)}
                >
                  <ListItemText primary={item.name} />
                </ListItem>
              ))}
              <Logout
                data={this.props}
                cancel={this.toggleDrawer('right', false)}
              />
            </List>
          </div>
        );
      }
    };
    const sideList = (
      <div className={classes.list}>
        {/* ----- Displaying the Sign and Login button when user is not logged in -----Start here */}
        {checkLoginStatus()}
        {/* ----- Displaying the Sign and Login button when user is not logged in ----- end here */}

        {displayUsrProfile()}

        <List>
          {genericLinks.map((item, index) => (
            <ListItem
              button
              key={item.name}
              component={Link}
              to={item.link}
              onClick={this.toggleDrawer('right', false)}
              onKeyDown={this.toggleDrawer('right', false)}
            >
              <ListItemText primary={item.name} />
            </ListItem>
          ))}
        </List>
        <Divider />
        {/* ----- Displaying Profile setting, My preference, My Board and Logout when user is login -----Start here */}
        {displayWhenUserLogin()}
        {/* ----- Displaying Profile setting, My preference, My Board and Logout when user is login -----Ends here */}
      </div>
    );
    return (
      <div>
        <Button
          onClick={this.toggleDrawer('right', true)}
          color="secondary"
          variant="outlined"
        >
          <strong>Explore</strong>
        </Button>
        <SwipeableDrawer
          anchor="right"
          open={this.state.right}
          onClose={this.toggleDrawer('right', false)}
          onOpen={this.toggleDrawer('right', true)}
        >
          <div tabIndex={0} role="button">
            {sideList}
          </div>
        </SwipeableDrawer>
      </div>
    );
  }
}

SwipeableTemporaryDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}
export default connect(mapStateToProps)(
  withStyles(styles)(SwipeableTemporaryDrawer)
);
